const prefix = '[Question]';

export class UpdateSelection {
    static readonly type = `${prefix} Update Selection`;
    constructor(
        public category: string,
        public field: string,
        public values: string[]
    ) {}
}

export class LoadQuestionBank {
    static readonly type = `${prefix} Load Question Bank`;
}

export class ToggleQuestionChecked {
    static readonly type = `${prefix} Toggle Question Checked`;
    constructor(
        public category: string,
        public questionId: string
    ) {}
}

export class AddSelectionToInterview {
    static readonly type = `${prefix} Add Selection To Interview`;
    constructor(public interviewerNum: number) {}
}

export class RemoveSelectionFromInterview {
    static readonly type = `${prefix} Remove Selection From Interview`;
    constructor(public interviewerNum: number) {}
}

export class ClearActiveSelection {
    static readonly type = `${prefix} Clear Active Selection`;
}

export class ClearInterviewerQuestions {
    static readonly type = `${prefix} Clear Interviewer Questions`;
    constructor(public interviewerNum: number) {}
}

export class AddCustomQuestion {
    static readonly type = `${prefix} Add Custom Question`;
    constructor(
        public category: string,
        public text: string
    ) {}
}

export class RemoveCustomQuestion {
    static readonly type = `${prefix} Remove Custom Question`;
    constructor(
        public category: string,
        public questionId: string
    ) {}
}

export class EditCustomQuestion {
    static readonly type = `${prefix} Edit Custom Question`;
    constructor(
        public category: string,
        public questionId: string,
        public text: string
    ) {}
}
export class RemoveQuestionFromInterview {
    static readonly type = `${prefix} Remove Question From Interview`;
    constructor(
        public interviewerNum: number,
        public questionId: string
    ) {}
}
